import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import store from '../store/index'

const router = createRouter({
  history: createWebHistory(window.baseUrl || '/'),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      const el = document.querySelector(to.hash)
      if (el) {
        return window.scrollTo({
          top: el.offsetTop - 80,
          behavior: 'smooth'
        })
      }
    }
    return { left: 0, top: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.access === 'all') {
    next()
  } else if (to.meta.access === 'private') {
    store.getters.isLoggedIn ? next() : next({ name: 'login' })
  } else if (store.getters.isLoggedIn) {
    next({ name: 'home' })
  } else {
    next()
  }

  if (store.getters.isLoggedIn) {
    store.dispatch('getUser')
  }
  store.commit('toggleMenu', false)
  document.querySelector('body').classList.toggle('overflow-hidden', false)
})

export default router

